import { useContext } from "react";
import Context from "../../../common/components/utils/context";

export const AdminFormsForm = () => {
  const context = useContext(Context);

  return (
    <div className="container mb-auto relative">
      <iframe
        title="Forms"
        src={`https://foundat-62677.bubbleapps.io/dashboard/form?user_id=${context.cryptedUserID}&company_id=${context.cryptedCompanyID}&role_id=${context.cryptedRole}`}
        className="w-full h-screen"
      />
    </div>
  );
};
